<template>
  <div class="tw-mb-10 tw-border-b-2">
    <ul
      class="tw--mb-px tw-flex tw-flex-wrap tw-gap-4 tw-text-center tw-text-sm tw-font-bold tw-text-gray-600 lg:tw-gap-8"
    >
      <li v-for="(tab, index) in tabs" :key="index">
        <a
          href
          @click.prevent="activeTab = tab.origin"
          :class="[activeTab === tab.origin ? 'active-tab active' : 'tw-border-transparent']"
          class="tab-item group tw-inline-flex tw-items-center tw-space-x-0.5 tw-rounded-t-lg tw-border-b-2 tw-pb-2 tw-pt-0 lg:tw-space-x-3"
        >
          <img :src="tab.icon" class="tw-h-7 tw-w-7" :title="tab.label" />
          <span class="[@media(max-width:387px)]:tw-hidden">
            <span class="tw-ml-3 lg:tw-ml-0">{{ tab.label }}</span>
            <span class="tw-hidden lg:tw-inline-block">&nbsp;Reviews</span>
          </span>
          <span
            class="tw-flex tw-min-h-[1.75rem] tw-min-w-[1.75rem] tw-items-center tw-justify-center tw-rounded-full tw-p-1"
          >
            ({{ Number(tab.count).toLocaleString() }})
          </span>

          <Badge :value="tab.rating" severity="warn" v-if="tab.count" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  tabs: Array,
  modelValue: String,
});

const emit = defineEmits(['update:modelValue']);

const activeTab = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<style scoped>
.active-tab {
  border-color: v-bind('$page.props.customisation.primary_background');
}

.tab-item:hover {
  border-color: v-bind('$page.props.customisation.primary_background');
}
</style>
